import React from 'react'
import Shape1 from '../../assets/images/shapes/testimonial-three-shape-1.png'
import Shape2 from '../../assets/images/shapes/services-details-content-shape-1.png'
import Content from '../../assets/images/resources/services-details-content-img.jpg'

function ServiceDetails() {
  return (
    <div>
      <section className="services-details-content">
        <div className="services-details-content-shape-1">
          <div className="animation_image_zoom">
            <div className="services-details-content-shape-1-img">
              <img
                src={Shape1}
                alt="testimonial-three-shape-1"
              />
            </div>
          </div>
        </div>
        <div className="services-details-content-shape-2">
          <div className="animation_image_zoom">
            <div className="services-details-content-shape-2-img">
              <img
                src={Shape2}
                alt="services-details-content-shape-1"
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12">
              <div className="services-details-content-title-box">
                <div
                  className="section-three-title wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="section-three-title-title">
                    <h2>
                      Increase Your Web Traffic &amp; grow your Product sale
                      with SEO Solutions
                    </h2>
                  </div>
                </div>
                <div
                  className="section-three-details wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <p>
                    Digital marketing &amp; advertising approach focuses on
                    capturing the essential
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
              <div
                className="services-details-content-img-box wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <div className="scroll_item_select_img ">
                  <img
                    src={Content}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ServiceDetails
